import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import axios from 'axios';
import 'url-search-params-polyfill';
import UAParser from 'ua-parser-js';

export const log = (category, action, label) => {
	console.log('--- GA', category, action, label);
	trackCustomEvent({
		category: category,
		action: action,
		label: label,
	});
};

export const fblog = (type, event, config) => {
	if (typeof config !== 'undefined') {
		console.log('--- FB', type, event, config);
		typeof window !== 'undefined' && window.fbq && window.fbq(type, event, config);
	} else {
		console.log('--- FB', type, event);
		typeof window !== 'undefined' && window.fbq && window.fbq(type, event);
	}
};

export const splog = (event, config) => {
	if (typeof config !== 'undefined') {
		console.log('--- SP', event, config);
		typeof window !== 'undefined' && window.snaptr && window.snaptr('track', event, config);
	} else {
		console.log('--- SP', event);
		typeof window !== 'undefined' && window.snaptr && window.snaptr('track', event);
	}
};

export const eclog = (plan, event, extra) => {
	if (typeof window !== 'undefined' && typeof window.ga !== 'undefined') {
		window.ga('require', 'ec');
		if (plan) {
			window.ga('ec:addProduct', {
				id: 'plan_' + plan.name,
				name: 'Plan ' + plan.title,
			});
		} else {
			window.ga('ec:addProduct', {
				id: 'plan_overview',
				name: 'Plan Overview',
			});
		}
		switch (event) {
			case 'detail':
				window.ga('ec:setAction', 'detail');
				console.log('--- EC', event, 'plan_overview');
				break;
			case 'click':
				window.ga('ec:setAction', 'click');
				console.log('--- EC', event, 'plan_' + plan.name);
				break;
			case 'add':
				window.ga('ec:setAction', 'add');
				console.log('--- EC', event, 'plan_' + plan.name);
				break;
			case 'checkout':
				window.ga('ec:setAction', 'checkout');
				console.log('--- EC', event, 'plan_' + plan.name);
				break;
			case 'purchase':
				window.ga('ec:setAction', 'purchase', {
					id: extra,
					revenue: plan.price_usd,
				});
				console.log('--- EC', event, 'plan_' + plan.name, plan.price_usd, extra);
				break;
			default:
				break;
		}
		window.ga('send', 'event');
	} else {
		console.log('ga undefined');
	}
};

export const slog = (event, email) => {
	const params = [];
	for (var item of new URLSearchParams(document.location.search)) {
		params.push({ key: item[0], value: item[1] });
	}
	let ua = new UAParser().getResult();
	params.push({
		key: 'UA',
		value: `${ua.os.name} ${ua.os.version}, ${ua.browser.name} ${ua.browser.version} [${ua.ua}]`,
	});
	axios.post('/.netlify/functions/hook', {
		data: {
			env:
				process.env.NODE_ENV === 'production' &&
				!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify'))
					? 'prod'
					: 'dev',
			url: window.location.href.split('?')[0],
			email: email,
			params: params,
			event: event,
		},
	});
};
